import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const CustomMaterialForm = () => {
	const [formData, setFormData] = useState({
		parentName: '',
		studentName: '',
		email: '',
		materialType: '',
		fullOrCut: '',
		cutLength: '',
		trackType: '',
		purpose: '',
		purposeOther: '',
		deadline: '',
		notes: '',
	});
	const [submitted, setSubmitted] = useState(false);

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log('📨 Submitting form data:', formData);

		const emailData = {
			parentName: formData.parentName || '',
			studentName: formData.studentName || '',
			email: formData.email || '',
			materialType: formData.materialType || '',
			fullOrCut: formData.fullOrCut || '',
			cutLength: formData.cutLength || '',
			trackType: formData.trackType || '',
			purpose: formData.purpose || '',
			purposeOther: formData.purposeOther || '',
			deadline: formData.deadline || '',
			notes: formData.notes || '',
			title: `New Material Request – ${
				formData.materialType || 'Material'
			} for ${formData.purpose || 'General'} (Student: ${
				formData.studentName || 'N/A'
			})`,
		};

		console.log('📬 Sending email with data:', emailData);

		emailjs
			.send(
				'service_nmrlx4g',
				'template_tnuem5l',
				emailData,
				'eGI4pnvCADdYo0bBG'
			)
			.then((result) => {
				console.log(
					'✅ Email successfully sent:',
					result.status,
					result.text
				);
				// alert removed — success message now shown only through UI
				setSubmitted(true);
			})
			.catch((error) => {
				console.error('❌ EmailJS Error Details:', error);
				alert(`Something went wrong: ${error?.text || error}`);
			});
	};

	if (submitted) {
		return (
			<div
				className='p-4 text-center'
				style={{
					backgroundColor: '#fef9f6',
					border: '2px solid #f0a8c0',
					borderRadius: '12px',
					maxWidth: '600px',
					margin: '2rem auto',
				}}>
				<h4 style={{ color: '#384971' }}>✅ Request Submitted!</h4>
				<p style={{ fontSize: '1.05rem', margin: '1rem 0' }}>
					Thank you for your submission. We’ll review your request and
					reach out soon if we need anything else.
				</p>
				<button
					className='btn btn-outline-dark mt-3 mb-3'
					onClick={() => setSubmitted(false)}>
					Submit another request
				</button>
				<p style={{ fontSize: '0.95rem', color: '#666' }}>
					If you have any questions in the meantime, feel free to
					email us at{' '}
					<a
						href='mailto:requests@coloryourvoice.com'
						style={{ color: '#82c6c6' }}>
						requests@coloryourvoice.com
					</a>
					.
				</p>
			</div>
		);
	}

	return (
		<form onSubmit={handleSubmit} className='p-3 border rounded shadow-sm'>
			<div className='mb-3'>
				<label className='form-label'>
					Your Name (Parent or Guardian)
				</label>
				<input
					type='text'
					name='parentName'
					className='form-control'
					value={formData.parentName}
					onChange={handleChange}
					required
				/>
			</div>
			<div className='mb-3'>
				<label className='form-label'>Student Name</label>
				<input
					type='text'
					name='studentName'
					className='form-control'
					value={formData.studentName}
					onChange={handleChange}
					required
				/>
			</div>
			<div className='mb-3'>
				<label className='form-label'>Your Email</label>
				<input
					type='email'
					name='email'
					className='form-control'
					value={formData.email}
					onChange={handleChange}
					required
				/>
			</div>
			<div className='mb-3'>
				<label className='form-label'>
					Do you need sheet music, a track, or both?
				</label>
				<select
					name='materialType'
					className='form-select'
					value={formData.materialType}
					onChange={handleChange}
					required>
					<option value='' disabled>
						Select an option
					</option>
					<option value='Sheet Music'>Sheet Music</option>
					<option value='Backing Track'>Backing Track</option>
					<option value='Both'>Both</option>
				</select>
			</div>
			<div className='mb-3'>
				<label className='form-label'>
					Is this for the full song or a specific cut?
				</label>
				<select
					name='fullOrCut'
					className='form-select'
					value={formData.fullOrCut}
					onChange={handleChange}
					required>
					<option value='' disabled>
						Select an option
					</option>
					<option value='Full Song'>Full Song</option>
					<option value='Cut'>Cut</option>
				</select>
			</div>
			{formData.fullOrCut === 'Cut' && (
				<div className='mb-3'>
					<label className='form-label'>
						If a cut, how long should it be? (bars or time)
					</label>
					<small className='text-muted d-block mb-1'>
						Don’t worry if you’re unsure — a rough estimate is
						totally fine! You can say something like "16 bars" or
						"about 45 seconds."
					</small>
					<input
						type='text'
						name='cutLength'
						className='form-control'
						value={formData.cutLength}
						onChange={handleChange}
					/>
				</div>
			)}
			{(formData.materialType === 'Backing Track' ||
				formData.materialType === 'Both') && (
				<div className='mb-3'>
					<label className='form-label'>
						What kind of track do you need?
					</label>
					<select
						name='trackType'
						className='form-select'
						value={formData.trackType || ''}
						onChange={handleChange}
						required>
						<option value='' disabled>
							Select an option
						</option>
						<option value='I need a performance track'>
							I need a performance track
						</option>
						<option value='I need a learning track'>
							I need a learning track
						</option>
						<option value='I need both'>I need both</option>
					</select>
				</div>
			)}
			<div className='mb-3'>
				<label className='form-label'>
					Why do you need this material? (Select the option that best
					describes your goal)
				</label>
				<select
					name='purpose'
					className='form-select'
					value={formData.purpose}
					onChange={handleChange}
					required>
					<option value='' disabled>
						Select an option
					</option>
					<option value='Audition'>Audition</option>
					<option value='Performance'>Performance</option>
					<option value='Learning'>Learning</option>
					<option value='Other'>Other</option>
				</select>
			</div>
			{formData.purpose === 'Other' && (
				<div className='mb-3'>
					<label className='form-label'>
						Please specify the purpose
					</label>
					<input
						type='text'
						name='purposeOther'
						className='form-control'
						value={formData.purposeOther}
						onChange={handleChange}
						required
					/>
				</div>
			)}
			<div className='mb-3'>
				<label className='form-label'>When do you need it by?</label>
				<input
					type='date'
					name='deadline'
					className='form-control'
					value={formData.deadline}
					onChange={handleChange}
				/>
			</div>
			<div className='mb-3'>
				<label className='form-label'>
					Anything else you'd like us to know?
				</label>
				<textarea
					name='notes'
					className='form-control'
					rows='3'
					value={formData.notes}
					onChange={handleChange}
				/>
			</div>
			<button type='submit' className='btn btn-dark'>
				Submit Request
			</button>
			<small
				className='text-muted d-block mt-3'
				style={{ fontSize: '0.85rem' }}>
				Once your request is confirmed, the associated fee will be added
				to your studio account by default unless you request an
				alternative arrangement.
			</small>
		</form>
	);
};

export default CustomMaterialForm;
